var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":"#3B5998","dark":"","large":""},on:{"click":function($event){return _vm.$emit('next')}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-facebook")]),_vm._v(" Continue with Facebook ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }